import type { ReactNode } from 'react';
import { cn } from '@/lib/utils';
import styles from './control-row.module.css';

/** A short label and its control stay aligned; only the control may shrink. */
export function ControlRow({ label, htmlFor, children, className }: { label: ReactNode; htmlFor?: string; children: ReactNode; className?: string }) {
  return <div className={cn(styles.row, className)} data-control-row>
    {htmlFor ? <label htmlFor={htmlFor} className={styles.label}>{label}</label> : <div className={styles.label}>{label}</div>}
    <div className={styles.control}>{children}</div>
  </div>;
}
